module.exports = __webpack_public_path__ + "img/hr-deepwater-green4.ced55086.png";